<template>
  <div>
    <base-material-card
      :title="title"
      full-width
    >
      <v-card-text>
            <v-form v-model="form.valid">
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.phone"
                      label="Телефон"
                      type="number"
                      :counter="11"
                      maxlength="11"
                      :rules="[(v) => (/7\d{10}/.test(v) || v.length == 0) || 'Неверное значение']"
                      required
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="form.role"
                      :items="select.role"
                      label="Роль"
                      required
                      v-if="$store.state.user.role == 1"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="form.client"
                      :items="select.clients"
                      label="Выберите физ.лицо"
                      item-value="id"
                      :filter="name_filter"
                      v-if="$store.state.user.role == 1"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" v-if="form.role == 3 || form.role == 6">
                    <v-select
                      label="Выберите направление деятельности"
                      v-model="form.kind"
                      :items="select.kind"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="form.password"
                      type="password"
                      label="Пароль"
                      required
                    />
                  </v-col>
                  <v-col
                    v-if="!profile"
                    cols="12"
                    md="6"
                  >
                    <v-checkbox
                      v-model="form.deleted"
                      label="Удалить"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="success"
          min-width="100"
          @click="create_user"
          :disabled="!valid.valid"
        >
          Сохранить
        </v-btn>
        <v-btn
          v-if="!profile"
          color="error"
          min-width="100"
          @click="$emit('close')"
        >
          Отмена
        </v-btn>
        <font color="red" class="ml-10">
          {{ valid.msg }}
        </font>
      </v-card-actions>
    </base-material-card>
  </div>
</template>

<script>
  import $ from 'jquery'
  import moment from 'moment'
  export default {
    props: ['user', 'title', 'data', 'show', 'profile'],
    data () {
      return {
        loader: {
          show: false
        },
        form: {
          id: '',
          phone: '',
          valid: false,
          surname: '',
          name: '',
          patronymic: '',
          role: '',
        },
        select: {
          role: [],
          file_type: [],
          clients: [],
          kind: [
            {value: 0, text: 'Страхование'},
            {value: 1, text: 'Центр оформления ДТП'}
          ],
        },
        table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
          {
            text: 'Тип',
            value: 'type'
          }
        ],
        }
      }
    },
    watch: {
      'show': function () {
        console.log(this.user)
        if (this.show) {
          this.load()
        }
      },
    },
    computed: {
      valid: {
        get() {
          if (this.form.insurer_agent || this.form.contract_agent) {
            let valid = false
            for (let x in this.form.files) {
              if (this.form.files[x].type> 0 && this.$store.state.dict.file_type[this.form.files[x].type].copy) {
                valid = true
              }
            }
            if (!valid) return { valid: false, msg: 'Необходимо загрузить доверенности' }
          }
          if (this.form.phone && this.form.role && this.form.valid) return { valid: true }
          return { valid: false, msg: 'Не заполнены все поля' }
        }
      }
    },
    mounted: function () {
      this.axios.post('/api/clients/list/', {})
        .then(response => {
          if (!response.data.error) {
            this.select.clients = response.data.data
            console.log(this.form.commissar)
          } else {

          }
        })
        .catch(e => {
          console.log(e)
        })
      for (let x in this.$store.state.dict.role) {
        this.select.role.push({ value: Number(x), text: this.$store.state.dict.role[x].name })
      }
      for (let x in this.$store.state.dict.file_type) {
        this.select.file_type.push({ value: Number(x), text: this.$store.state.dict.file_type[x].name })
      }
      this.load()
    },
    methods: {
      name_filter: function (item, query, text) {
        if ((item.surname + ' ' + item.name + ' ' + item.patronymic).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
            getDoc: function (item) {
        console.log(item)
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
            upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          let data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              } else {
                for (let x in response.data.data)
                {
                  this.form.files.push(response.data.data[x])
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      create_user: function () {
        if (!this.user) { this.$emit('create', this.form) } else this.$emit('save', this.form)
      },
      load: function () {
        if (this.user) {
          this.form.id = this.user.id
          this.form.phone = this.user.phone
          this.form.name = this.user.name
          this.form.surname = this.user.surname
          this.form.patronymic = this.user.patronymic
          this.form.role = this.user.role
          this.form.deleted = this.user.deleted
          this.form.password = ''
          this.form.insurer_agent = this.user.insurer_agent || false
          this.form.contract_agent = this.user.contract_agent || false
          this.form.files = this.user.files || []
          this.form.agent_doc = this.user.agent_doc || {}
          this.form.client = this.user.client
          this.form.kind = this.user.kind
          if (this.form.agent_doc.date) this.form.agent_doc.date = moment(this.form.agent_doc.date).format('YYYY-MM-DD')
          if (this.form.agent_doc.from_date) this.form.agent_doc.from_date = moment(this.form.agent_doc.from_date).format('YYYY-MM-DD')
        } else {
          this.form = {
            phone: '',
            valid: false,
            surname: '',
            name: '',
            patronymic: '',
            role: '',
            deleted: false,
            agent_doc: {
              
            },
            files: []
          }
        }
      },
    },
  }
</script>
